import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import CompanyPyn from './CompanyPyn';
import MapContainer from '../maps/MapContainer';
import M from 'materialize-css';

class CompanyDetails extends Component {
  state = {
    pynObjects: false,
    currentPyn: null,
    currentAddres: '',
  };

  componentDidMount() {
    M.Tabs.init(this.Tabs);
  }

  componentDidUpdate() {
    this.loadPyns();
  }

  loadPyns() {
    const { pyns } = this.props;
    if (pyns) {
      let pynObjects = [];

      for (var key in pyns) {
        var value = pyns[key];
        pynObjects.push(value);
      }

      if (!this.state.pynObjects) {
        this.setState({
          pynObjects: pynObjects,
        });
      }
    }
  }

  onClick = (pyn) => {
    this.setState({
      currentPyn: { lat: pyn.pyn.latitude, lng: pyn.pyn.longitude },
      currentaddres: pyn.address,
    });
  };

  renderPyns() {
    if (this.state.pynObjects) {
      const x = this.state.pynObjects.map((pyn, i) => {
        return <CompanyPyn key={pyn.address} pyn={pyn} onClick={this.onClick.bind(null, pyn)} />;
      });

      return <div className="collection col s6">{x}</div>;
    } else {
      return <p>Loading pyns...</p>;
    }
  }

  render() {
    const { company, auth } = this.props;
    if (!auth.uid) return <Redirect to="/signin" />;
    if (company) {
      return (
        <div className="container section project-details">
          <div className="card z-depth-0">
            <div className="card-content">
              <div className="company-container">
                <div className="company-thumb">
                  <img className="company-logo" src={company.iconUrl} alt={company.companyName} />
                </div>
                <div className="company-content">
                  <span className="card-title">{company.companyName}</span>
                  <p>
                    {company.address}
                    <br />
                    {company.location ? company.location.latitude + ',' + company.location.longitude : ''}
                    <br />
                  </p>
                </div>
              </div>
              <hr />
              <div className="col s12">
                <ul
                  className="tabs"
                  ref={(Tabs) => {
                    this.Tabs = Tabs;
                  }}>
                  <li className="tab col s3">
                    <a className="active" href="#pynsTab">
                      Pyns
                    </a>
                  </li>
                  <li className="tab col s3">
                    <a href="#rewardsTab">Rewards</a>
                  </li>
                </ul>
              </div>
              <div id="pynsTab" className="col s12">
                <div className="row">
                  {this.renderPyns()}
                  <div className="col s6">
                    <MapContainer pyns={this.state.pynObjects} center={this.state.currentPyn} className="col s6" />
                    <div className="center">{this.state.currentaddres}</div>
                  </div>
                </div>
              </div>
              <div id="rewardsTab" className="col s12"></div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container center">
          <p>Loading company...</p>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const companyId = ownProps.match.params.id;
  const company = state.firestore.data['currentCompany'];
  const pyns = state.firestore.data['companyPyns'];
  return {
    id: companyId,
    pyns: pyns,
    company: company ? company[companyId] : null,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    {
      collection: 'companies',
      where: ['uid', '==', props.id],
      storeAs: 'currentCompany'
    },
    {
      collection: 'pyns',
      where: ['uidCompany', '==', props.id],
      storeAs: 'companyPyns',
    },
  ]),
)(CompanyDetails);
